import React, { Component } from 'react';
import { Grid, } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import useStyles from './mobileStyles';
import { createRefetchContainer, graphql } from 'react-relay';
import { Bar } from 'react-chartjs-2';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

class WMMobileLeaderboard extends Component {
    constructor(props){
        super(props);
        this.state = {
            leaderboard: [],
            total_page: 1,
        }
    }

    componentDidMount(){
        const { getLonewolfPersonalLeaderboardData } = this.props;
        if(getLonewolfPersonalLeaderboardData && getLonewolfPersonalLeaderboardData.getLonewolfPersonalLeaderboardData){
            const data = getLonewolfPersonalLeaderboardData.getLonewolfPersonalLeaderboardData.data;
            this.setState({
                leaderboard: data.leaderboard,
                total_page: data.total_page
            });
        }
    }

    render(){
        const { classes, page_number, user, landscape } = this.props;
        const { leaderboard, total_page } = this.state;

        return ([
            <table className={landscape ? classes.wmTableLS : classes.wmTable} key='wm-mobile-lead'>
                <colgroup>
                    <col style={{width: '20%'}} />
                    <col style={{width: '55%'}} />
                    <col style={{width: '25%'}} />
                </colgroup>
                <thead>
                    <tr>
                        <th className={classes.wmTableHead} style={{textAlign: 'center'}}>PLACE</th>
                        <th className={classes.wmTableHead} style={{textAlign: 'left'}}>PLAYER</th>
                        <th className={classes.wmTableHead} style={{textAlign: 'center'}}>WINNINGS</th>
                    </tr>
                </thead>
                <tbody>
                {
                    leaderboard.map((l, i) => {
                        return (
                            <tr key={`leaderboard-${i}`}>
                                <td className={classes.wmTableRow} style={{textAlign: 'center'}}>{l.position}</td>
                                <td className={classes.wmTableRow} style={{textAlign: 'left'}}>{l.name}</td>
                                <td className={classes.wmTableRow} style={{textAlign: 'center'}}>${l.points}</td>
                            </tr>
                        )
                    })
                }
                {
                    user && user.name ?
                    <tr style={{backgroundColor: '#024731'}}>
                        <td className={classes.wmTableUser} style={{textAlign: 'center'}}>{user.position}</td>
                        <td className={classes.wmTableUser} style={{textAlign: 'left'}}>{user.name}</td>
                        <td className={classes.wmTableUser} style={{textAlign: 'center'}}>${user.points}</td>
                    </tr>
                    :
                    <></>
                }
                </tbody>
            </table>,
            <div key='mobile-pagination'>
                <div style={{float: 'right', marginTop: '1em'}}>
                {
                    page_number > 1 ?
                    <span className={classes.pageArrow2} onClick={() => this.props.changePage(page_number - 1)}>←</span> :
                    <span className={classes.pageArrowDisabled2}>←</span>
                }
                {
                    Array(total_page).fill(0).map((pg, i) => {
                        if(i + 1 == page_number) return <FiberManualRecordIcon className={classes.currentPage} key={`circleicon-${i}`} />
                        else return <FiberManualRecordIcon className={classes.otherPage} onClick={() => this.props.changePage(i + 1)} key={`circleicon-${i}`} />
                    })
                }
                {
                    page_number + 1 <= total_page ? 
                    <span className={classes.pageArrow2} onClick={() => this.props.changePage(page_number + 1)}>→</span> :
                    <span className={classes.pageArrowDisabled2}>→</span>
                }
                </div>
            </div>
        ])
    }
}

export default createRefetchContainer(
    withStyles(useStyles)(WMMobileLeaderboard),
    {
        getLonewolfPersonalLeaderboardData: graphql`
            fragment WMMobileLeaderboard_getLonewolfPersonalLeaderboardData on Query
                @argumentDefinitions(
                    event_token: { type: "String!" }
                    guest_token: { type: "String!" }
                    quarter_id: { type: "Int!" }
                    page_number: { type: Int }
                    search_val: { type: String }
                ){
                    getLonewolfPersonalLeaderboardData(event_token: $event_token, guest_token: $guest_token, quarter_id: $quarter_id, page_number: $page_number, search_val: $search_val){
                        data {
                            leaderboard {
                                name
                                points
                                position
                            }
                            total_page
                        }
                    }
                }
        `
    },
    graphql`
        query WMMobileLeaderboardRefetchQuery($event_token: String!, $guest_token: String!, $quarter_id: Int!, $page_number: Int, $search_val: String){
            ...WMMobileLeaderboard_getLonewolfPersonalLeaderboardData @arguments(event_token: $event_token, guest_token: $guest_token, quarter_id: $quarter_id, page_number: $page_number, search_val: $search_val)
        }
    `,
);